import { posthog } from "posthog-js";

import type { CaptureEvent } from "./events";

/**
 * Capture an analytics event.
 * Thin abstraction over PostHog to enable future provider flexibility.
 *
 * @param eventName - Name of the event (use snake_case convention)
 * @param properties - Optional properties/metadata for the event
 *
 * @example
 * captureEvent("page_created", { page_name: "My Page" });
 * captureEvent("user_logout");
 */
export const captureRawEvent = (eventName: string, properties?: Record<string, unknown>) => {
  if (typeof posthog === "undefined" || !posthog.capture) {
    console.debug("Analytics tracking is disabled or blocked");
    return;
  }
  try {
    posthog.capture(eventName, properties);
  } catch (error) {
    console.error("Error capturing event", { error, eventName });
  }
};

export const captureEvent: CaptureEvent = captureRawEvent;
